import StackedBarChart from './StackedBarChart';

export default StackedBarChart;
export * from './StackedBarChart';
